import React, { memo, useCallback } from 'react';
import { StyleSheet } from 'react-native';
import Animated, { Easing, useAnimatedStyle, withTiming } from 'react-native-reanimated';
import { Button, rem, Spacer } from 'design-system';
import { useAppSelector } from 'store/hooks';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useDepositToGIA } from '../hooks/useDepositToGIA';
import { selectIsTradingAccountAlpaca } from '../reducers/selectors';
import { isWeb } from '../../../constants';
const BuyScreenDepositButton = ({ showContent }) => {
    const isAlpacaAccount = useAppSelector(selectIsTradingAccountAlpaca);
    const { onDeposit } = useDepositToGIA('buy');
    const { width } = useAppFrameDimensions(isWeb);
    const maxViewWidth = (width - rem(24)) / 2;
    const handleDepositGIA = useCallback(() => {
        if (!isAlpacaAccount) {
            onDeposit();
        }
    }, [isAlpacaAccount, onDeposit]);
    const animatedStyles = useAnimatedStyle(() => ({
        width: withTiming(showContent ? maxViewWidth : 0, {
            duration: 150,
            easing: Easing.cubic,
        }),
    }), [maxViewWidth, showContent]);
    return (<Animated.View style={[styles.container, animatedStyles]}>
      <Button brandReversed title="Deposit" flex onPress={handleDepositGIA}/>
      <Spacer w={8}/>
    </Animated.View>);
};
export default memo(BuyScreenDepositButton);
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        // Collapsed to 0 width when hidden; without this the button still shows on web
        ...(isWeb && { overflow: 'hidden' }),
    },
});
